SSWClient = function(consumer_key, consumer_secret, redirect_uri) {
  var _service_domain = '12storeez.uz';
  var _scheme = '//';
  var _api_path = '/apps/ssw/api/';
  var _authorize_path = 'authorize';
  var _access_token_path = 'access_token';

  var api_url, authorize_url, access_token_url, token, self;

  api_url = _scheme + _service_domain + _api_path;
  authorize_url = api_url + _authorize_path;
  access_token_url = api_url + _access_token_path;

  self = this;
  this.getAuthorizationUri = function(hesid) {
    if (!redirect_uri) {
      throw new Exception('redirect_uri is not defined');
    }
    var data = {
      'response_type': 'code',
      'state': Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1),
      'client_id': consumer_key,
      'redirect_uri': redirect_uri
    };
    var authorizationUri = authorize_url + '?' + jQuery.param(data);

    return authorizationUri;
  };

  this.getAppToken = function(scopes, callback) {
    if (typeof scopes == 'function') {
      callback = scopes;
    }
    if (typeof scopes != 'string' || !scopes) {
      scopes = 'read_user write_user read_wishlist write_wishlist read_review write_review read_gallery write_reward';
    }

    var payload = {
      'client_id': consumer_key,
      'client_secret': consumer_secret,
      'scope': scopes,
      'grant_type': 'client_credentials',
    };

    self.request('POST', _access_token_path, payload, function(response) {
      var result = false;
      if (response && typeof response.access_token != 'undefined') {
        result = true;
        self.setAccessToken(response.access_token);
      }
      if (typeof callback == 'function') {
        callback(result);
      }
    });
  };

  this.setAccessToken = function(access_token) {
    token = access_token;
  };

  this.call = function(method, path, params, callback) {
    var url = api_url + path;
    if (typeof path == 'undefined') {
      throw new Exception('You must specify a request url.');
    }
    if (typeof path !== 'string') {
      throw new Exception('String expected, got ' + typeof path);
    }

    params.access_token = token;
    if (method == 'PUT') {
      url += '?' + jQuery.param(params);
    } else if (method == 'DELETE') {
      url += '?' + jQuery.param(params);
      delete params.access_token;
    }

    jQuery.ajax({
      'url': url,
      'method': method,
      'data': params,
      'headers': {'X-SSW-Access-Token': token}
    }).always(function(data, textStatus, jqXHR) {
      if (typeof callback == 'function') {
        callback(data, textStatus, jqXHR);
      }
    });

  };

  this.request = function(method, path, params, callback) {
    jQuery.ajax({
      'url': api_url + path,
      'method': method,
      'data': params
    }).always(function(data, textStatus, jqXHR) {
      if (typeof callback == 'function') {
        callback(data, textStatus, jqXHR);
      }
    });
  };

  this.getUsers = function(limit, page, callback) {
    if (typeof callback == 'undefined' && arguments.length) {
      var lastArgument = arguments[arguments.length - 1];
      callback = (typeof lastArgument == 'function') ? lastArgument : callback;
    }
    if (typeof limit !== 'number' || !limit) {
      limit = 250;
    }
    if (typeof page !== 'number' || !page) {
      page = 1;
    }

    self.call('GET', 'users', {'limit': limit, 'page': page}, callback);
  };

  this.getUser = function(user_id, callback) {
    self.call('GET', 'users/' + user_id, callback);
  };

  this.editUser = function(user_id, user_data, callback) {
    self.call('PUT', 'users/' + user_id, user_data, callback);
  };

  this.searchUser = function(email, callback) {
    self.call('GET', 'users/search', {'email': email}, callback);
  };

  this.getWishlist = function(user_id, board_id, limit, page, callback) {
    if (typeof callback == 'undefined' && arguments.length) {
      var lastArgument = arguments[arguments.length - 1];
      callback = (typeof lastArgument == 'function') ? lastArgument : callback;
    }
    if (typeof user_id !== 'number' || !user_id) {
      user_id = 0;
    }
    if (typeof board_id !== 'number' || !board_id) {
      board_id = 0;
    }
    if (typeof limit !== 'number' || !limit) {
      limit = 250;
    }
    if (typeof page !== 'number' || !page) {
      page = 1;
    }
    var data = {'user_id': user_id, 'board_id': board_id, 'limit': limit, 'page': page};
    self.call('GET', 'wishlist', data, callback);
  };

  this.addToWishlist = function(user_id, product_id, board_id, callback) {
    if (typeof callback == 'undefined' && arguments.length) {
      var lastArgument = arguments[arguments.length - 1];
      callback = (typeof lastArgument == 'function') ? lastArgument : callback;
    }
    if (typeof board_id !== 'number' || !board_id) {
      board_id = 0;
    }
    var data = {'user_id': user_id, 'product_id': product_id, 'board_id': board_id};
    self.call('POST', 'wishlist', data, callback);
  };

  this.removeFromWishlist = function(user_id, product_id, callback) {
    if (typeof callback == 'undefined' && arguments.length) {
      var lastArgument = arguments[arguments.length - 1];
      callback = (typeof lastArgument == 'function') ? lastArgument : callback;
    }
    var data = {'user_id': user_id, 'product_id': product_id};
    self.call('DELETE', 'wishlist', data, callback);
  };

  this.reviews = function(product_id, user_id, limit, page, callback) {
    if (typeof callback == 'undefined' && arguments.length) {
      var lastArgument = arguments[arguments.length - 1];
      callback = (typeof lastArgument == 'function') ? lastArgument : callback;
    }
    if (typeof user_id !== 'number' || !user_id) {
      user_id = null;
    }
    if (typeof limit !== 'number' || !limit) {
      limit = 250;
    }
    if (typeof page !== 'number' || !page) {
      page = 1;
    }

    var data = {'limit': limit, 'page': page, direction: 'DESC'};
    if (product_id !== null) {
      data.product_id = product_id;
    }
    if (user_id !== null) {
      data.user_id = user_id;
    }
    self.call('GET', 'reviews', data, callback);
  };

  this.postReview = function(email, name, body, rate, title, product_id, callback) {
    if (typeof callback == 'undefined' && arguments.length) {
      var lastArgument = arguments[arguments.length - 1];
      callback = (typeof lastArgument == 'function') ? lastArgument : callback;
    }
    if (typeof email !== 'string' || !email) {
      email = '';
    }
    if (typeof name !== 'string' || !name) {
      name = '';
    }
    if (typeof body !== 'string' || !body) {
      body = '';
    }
    if (typeof title !== 'string' || !title) {
      title = '';
    }
    if (typeof rate !== 'number' || !rate) {
      rate = 0;
    }
    if (typeof product_id !== 'string' || !product_id) {
      product_id = 0;
    }

    var data = {'email': email, 'name': name, 'body': body, 'rate': rate, title, 'product_id': product_id};
    self.call('POST', 'reviews', data, callback);
  };

  this.rate = function(product_ids, limit, page, callback) {
    if (typeof callback == 'undefined' && arguments.length) {
      var lastArgument = arguments[arguments.length - 1];
      callback = (typeof lastArgument == 'function') ? lastArgument : callback;
    }
    if (typeof product_ids == 'undefined' || typeof product_ids == 'function' || !product_ids) {
      product_ids = null;
    }
    if (typeof limit !== 'number' || !limit) {
      limit = 250;
    }
    if (typeof page !== 'number' || !page) {
      page = 1;
    }

    var data = {'limit': limit, 'page': page};
    if (product_ids !== null) {
      data.product_ids = product_ids;
    }

    self.call('GET', 'reviews/products', data, callback);
  };

  this.getGalleries = function (limit, page, callback) {
    self.call('GET', 'galleries', {limit: limit, page: page}, callback);
  };

  this.getMedia = function (productId, galleryId, limit, page, callback) {
    self.call('GET', 'media', {product_id: productId, gallery_id: galleryId, limit: limit, page: page}, callback);
  };

  this.getQA = function (itemId, limit, page, callback) {
    self.call('GET', 'qa/' + itemId, {limit: limit, page: page}, callback);
  };

  this.earnReward = function (user_id, email, rule_type, points) {
    user_id = user_id || 0;
    email = email || null;
    rule_type = rule_type || '';
    points = points || 0;
    self.call('POST', 'reward/earn', {user_id: user_id, email: email, rule_type: rule_type, points: points});
  };

  this.getEarningRules = function (userId, all, callback) {
    userId = userId || 0;
    all = all || 0;
    self.call('GET', 'reward/earningRules', {user_id: userId, all: all}, callback);
  };
};



// Bamboo

// local storage wishlist
var bambooLocalSSWClient = function() {
  var self = this;
  var localStorageKey = 'bambooLocalWishlist';

  this.getAppToken = function(scopes, callback) {
    if (typeof scopes == 'function') {
      callback = scopes;
    }

    if (typeof callback == 'function') {
      callback(true);
    }
  };

  this.call = function(data, callback) {
    if (typeof callback == 'function') {
      callback({status: 200, data});
    }
  };

  this.searchUser = function(email, callback) {
    self.call({user_id: 'local'}, callback);
  };

  this.getWishlist = function(user_id, board_id, limit, page, callback) {
    if (typeof callback == 'undefined' && arguments.length) {
      var lastArgument = arguments[arguments.length - 1];
      callback = (typeof lastArgument == 'function') ? lastArgument : callback;
    }
    if (typeof user_id !== 'number' || !user_id) {
      user_id = 0;
    }
    if (typeof board_id !== 'number' || !board_id) {
      board_id = 0;
    }
    if (typeof limit !== 'number' || !limit) {
      limit = 250;
    }
    if (typeof page !== 'number' || !page) {
      page = 1;
    }

    self.call(self.getWishlistFromLocalStorage(), callback);
  };

  this.addToWishlist = function(user_id, product_id, board_id, callback) {
    if (typeof callback == 'undefined' && arguments.length) {
      var lastArgument = arguments[arguments.length - 1];
      callback = (typeof lastArgument == 'function') ? lastArgument : callback;
    }
    if (typeof board_id !== 'number' || !board_id) {
      board_id = 0;
    }

    var variant_id = 0;

    var data = {
      user_id: 'local',
      product_id: product_id,
      board_id: board_id,
      variant_id: variant_id,
      handle: bambooWishlistHelper.getHandleFromLocalStorage({productId: product_id, variantId: variant_id}),
    };

    var wishlist = self.getWishlistFromLocalStorage();

    wishlist.push(data);

    self.putWishlistToLocalStorage(wishlist);

    self.call({}, callback);
  };

  this.getWishlistFromLocalStorage = function() {
    return JSON.parse(localStorage.getItem(localStorageKey)) || [];
  };

  this.putWishlistToLocalStorage = function(wishlist) {
    localStorage.setItem(localStorageKey, JSON.stringify(wishlist));
  };

  this.removeFromWishlist = function(user_id, product_id, callback) {
    if (typeof callback == 'undefined' && arguments.length) {
      var lastArgument = arguments[arguments.length - 1];
      callback = (typeof lastArgument == 'function') ? lastArgument : callback;
    }

    var wishlist = self.getWishlistFromLocalStorage();

    wishlist = wishlist.filter(oneItem => oneItem.product_id != product_id);

    self.putWishlistToLocalStorage(wishlist);

    self.call({}, callback);
  };

  this.emptyLocalWishlist = function() {
    localStorage.removeItem(localStorageKey);
  };
};


// Expand bambooWishlistHelper object

bambooWishlistHelper.initAllHtmlElements = params => {

	Object.keys(bambooWishlistHelper.htmlElementsByProductId).forEach(productId => {

  	  Object.keys(bambooWishlistHelper.htmlElementsByProductId[productId].byVariantId).forEach(variantId => {

  		Object.keys(bambooWishlistHelper.htmlElementsByProductId[productId].byVariantId[variantId].byHtmlElementId)
		  .forEach(htmlElementId => {
            bambooWishlistHelper.initHtmlElement({htmlElementId});
          });
      });
    });
  };

bambooWishlistHelper.initHtmlElement = params => {
  const elements = [...document.querySelectorAll(`[data-id="${params.htmlElementId}"]`)];

  elements.forEach(e => {
    const bambooWishlist = JSON.parse((e.dataset.bambooWishlist));

    bambooWishlistHelper.htmlElementsByProductId[bambooWishlist.productId].byVariantId[bambooWishlist.variantId]
        .byHtmlElementId[bambooWishlist.htmlElementId].processing = true;

    if (!bambooWishlistHelper.byProductId[bambooWishlist.productId]) {

      return bambooWishlistHelper.initAsNotInWishlist(bambooWishlist);
    }

    if (bambooWishlist.variantId == 0) {
      return bambooWishlistHelper.initAsAddedToWishlist(bambooWishlist);
    }

    if (bambooWishlistHelper.byProductId[bambooWishlist.productId].byVariantId[0]) {
      return bambooWishlistHelper.initAsAddedToWishlist(bambooWishlist);
    }

    if (bambooWishlistHelper.byProductId[bambooWishlist.productId].byVariantId[bambooWishlist.variantId]) {
      return bambooWishlistHelper.initAsAddedToWishlist(bambooWishlist);
    }

    bambooWishlistHelper.initAsNotInWishlist(bambooWishlist);
  })
};

bambooWishlistHelper.initAsAddedToWishlist = params => {
  const elements = [...document.querySelectorAll(`[data-id="${params.htmlElementId}"]`)];

  elements.forEach(el => {
    el.innerHTML = bambooWishlistHelper.makeInWishlistHtml(params);

    el.onclick = bambooWishlistHelper.removeFromWishlistClickHandler;

    bambooWishlistHelper.endProcessing(params);
  })
};

bambooWishlistHelper.getBambooWishlistDatasetFromPath = params => {
  let el;

  if (params.e.path) {
    params.e.path.forEach(oneElement => {
      if (oneElement.dataset && oneElement.dataset.bambooWishlist) {
        el = oneElement;
      }
    });
  } else {
    el = params.e.currentTarget;
  }

  return el;
}

bambooWishlistHelper.saveHandleToLocalStorage = params => {
  localStorage.setItem(`bamboo_product_handle_${params.productId}_${params.variantId}`, params.handle);
  localStorage.setItem(`bamboo_product_handle_${params.productId}_0`, params.handle);
};

bambooWishlistHelper.getHandleFromLocalStorage = params => {
  return localStorage.getItem(`bamboo_product_handle_${params.productId}_${params.variantId}`);
};


bambooWishlistHelper.addToWishlistClickHandler = (e) => {
  const el = bambooWishlistHelper.getBambooWishlistDatasetFromPath({e});

  const id = el.dataset.id;

  const elements = [...document.querySelectorAll(`[data-id=${id}]`)];


    let productData = null;
    if (document.body.classList.contains('template-product')) {
      console.log(elements[0].dataset)
      productData = JSON.parse(elements[0].dataset.bambooWishlist);
    } else {
      productData = JSON.parse(el.parentNode.dataset.product);
    }


    window.googleTagManagerHandler.onAddToWishlist(productData);


    const bambooWishlist = JSON.parse(el.dataset.bambooWishlist);

  elements.forEach(el => {
    el.innerHTML = bambooWishlistHelper.makeAddingToWishlistHtml(bambooWishlist);
  })

  bambooWishlistHelper.saveHandleToLocalStorage(bambooWishlist);

  bambooSswclient.addToWishlist(bambooWishlistHelper.sswUserId, bambooWishlist.productId, addToWishlistRes => {
    if (addToWishlistRes.status !== 200) {
      console.warn('bambooSswclient: something went wrong with adding to wishlist');

      return;
    }

    const variantId = bambooWishlist.variantId || 0;

    bambooWishlistHelper.byProductId[bambooWishlist.productId] = {
      byVariantId: {
        [variantId]: true
      }
    };

    if (!bambooWishlistHelper.haveItems) {
      bambooWishlistHelper.haveItems = true;
      bambooWishlistHelper.onHaveItems();
    }

    bambooWishlistHelper.haveItems = true;


    bambooWishlistHelper.amountItemsInWishlist();

    el.onclick = bambooWishlistHelper.removeFromWishlistClickHandler;

    elements.forEach(el => {
      el.innerHTML = bambooWishlistHelper.makeInWishlistHtml(bambooWishlist);
    })
  });
};

bambooWishlistHelper.removeFromWishlistClickHandler = (e) => {
  const el = bambooWishlistHelper.getBambooWishlistDatasetFromPath({e});

  const id = el.dataset.id;

  const elements = [...document.querySelectorAll(`[data-id=${id}]`)];


  const bambooWishlist = JSON.parse(el.dataset.bambooWishlist);


  let productData = null;
  if (document.body.classList.contains('template-product')) {
    console.log(elements[0].dataset)
    productData = JSON.parse(elements[0].dataset.bambooWishlist);
  } else {
    productData = JSON.parse(el.parentNode.dataset.product);
  }

  window.googleTagManagerHandler.onRemoveFromWishlist(productData);


  elements.forEach(el => {
    el.innerHTML = bambooWishlistHelper.makeRemovingFromWishlistHtml(bambooWishlist);
  })

  bambooSswclient.removeFromWishlist(bambooWishlistHelper.sswUserId, bambooWishlist.productId, removeFromWishlistRes => {
    if (removeFromWishlistRes.status !== 200) {
      console.warn('bambooSswclient: something went wrong with removing from wishlist');

      return;
    }

    delete bambooWishlistHelper.byProductId[bambooWishlist.productId];

    if (Object.keys(bambooWishlistHelper.byProductId).length === 0) {
      if (bambooWishlistHelper.haveItems) {
        bambooWishlistHelper.haveItems = false;
        bambooWishlistHelper.onEmptyWishlist();
      }

      bambooWishlistHelper.haveItems = false;
    }

    bambooWishlistHelper.amountItemsInWishlist();

    elements.forEach(el => {

      el.onclick = bambooWishlistHelper.addToWishlistClickHandler;

      el.innerHTML = bambooWishlistHelper.makeNotInWishlistHtml(bambooWishlist);
    })

  });
};

bambooWishlistHelper.initAsNotInWishlist = params => {
  const elements = [...document.querySelectorAll(`[data-id="${params.htmlElementId}"]`)];

  elements.forEach(el => {

    el.innerHTML = bambooWishlistHelper.makeNotInWishlistHtml(params);

    el.onclick = bambooWishlistHelper.addToWishlistClickHandler;

    bambooWishlistHelper.endProcessing(params);
  })
};

bambooWishlistHelper.endProcessing = params => {
  bambooWishlistHelper.htmlElementsByProductId[params.productId].byVariantId[params.variantId]
    .byHtmlElementId[params.htmlElementId].processing = false;

  bambooWishlistHelper.htmlElementsByProductId[params.productId].byVariantId[params.variantId]
    .byHtmlElementId[params.htmlElementId].processed = true;
};

bambooWishlistHelper.syncLocalWishlist = params => {
  params.localWishlist.map(oneItem => {
    bambooSswclient.addToWishlist(bambooWishlistHelper.sswUserId, oneItem.product_id);
  });

  params.bambooLocalSswclient.emptyLocalWishlist();
};

bambooWishlistHelper.onHaveItems = () => {
  document.getElementById("bambooWishlistLink").innerHTML = '<svg class="wishlist-completed" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<path d="M17.5 2.5H6.5V21.5C8.59224 16.4786 15.4078 16.4786 17.5 21.5V2.5Z" stroke="#4F3E35" stroke-linejoin="round"></path>\n' +
      '</svg>'
};

bambooWishlistHelper.onEmptyWishlist = () => {
 document.getElementById("bambooWishlistLink").innerHTML = '<svg class="wishlist" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
     '<path d="M17.5 2.5H6.5V21.5C8.59224 16.4786 15.4078 16.4786 17.5 21.5V2.5Z" stroke="#4F3E35" stroke-linejoin="round"/>\n' +
     '</svg>'
};

bambooWishlistHelper.makeInWishlistHtml = (params) => {
  //return 'In wishlist';

  if (params.type == "ProductPage") {
    return '<div class="bbw-fave-content bbw-fave-active"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2.5C6 2.22386 6.22386 2 6.5 2H17.5C17.7761 2 18 2.22386 18 2.5V21.5C18 21.7383 17.8318 21.9435 17.5981 21.9903C17.3643 22.037 17.1301 21.9123 17.0385 21.6923C15.1172 17.0812 8.88284 17.0812 6.96154 21.6923C6.86987 21.9123 6.63565 22.037 6.40194 21.9903C6.16823 21.9435 6 21.7383 6 21.5V2.5Z" fill="#4F3E35"/> </svg></div>';
  }

  if (params.type == "ProductGridItem") {
    return '<svg class="active" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M6 2.5C6 2.22386 6.22386 2 6.5 2H17.5C17.7761 2 18 2.22386 18 2.5V21.5C18 21.7383 17.8318 21.9435 17.5981 21.9903C17.3643 22.037 17.1301 21.9123 17.0385 21.6923C15.1172 17.0812 8.88284 17.0812 6.96154 21.6923C6.86987 21.9123 6.63565 22.037 6.40194 21.9903C6.16823 21.9435 6 21.7383 6 21.5V2.5Z" fill="#FFFFFF"/>\n' +
        '</svg>'
  }

  console.warn('bambooSswclient: cant build in wishlist html');
};

bambooWishlistHelper.makeNotInWishlistHtml = (params) => {
  if (params.type == "ProductPage") {
    //return 'Add To Wishlist [ProductPage]';
    return '<div class="bbw-fave-content"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="24" height="24" transform="translate(0 0.000976562)" fill="white" style="mix-blend-mode:multiply"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2.50098C6 2.22483 6.22386 2.00098 6.5 2.00098H17.5C17.7761 2.00098 18 2.22483 18 2.50098V21.501C18 21.7393 17.8318 21.9445 17.5981 21.9913C17.3643 22.038 17.1301 21.9133 17.0385 21.6933C15.1172 17.0822 8.88284 17.0822 6.96154 21.6933C6.86987 21.9133 6.63565 22.038 6.40194 21.9913C6.16823 21.9445 6 21.7393 6 21.501V2.50098ZM7 3.00098V19.6595C9.54762 16.4267 14.4524 16.4267 17 19.6595V3.00098H7Z" fill="#4F3E35"/> </svg> </div>'
  }

  if (params.type == "ProductGridItem") {
    return '<svg class="inactive" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.3833 2.63959H6.21666V18.4729C7.96019 14.2884 13.6398 14.2884 15.3833 18.4729V2.63959Z" fill="#5E5D5D" fill-opacity="0.6"/> <path d="M15.6333 2.63959C15.6333 2.50152 15.5214 2.38959 15.3833 2.38959H6.21666C6.07859 2.38959 5.96666 2.50152 5.96666 2.63959V18.4729C5.96666 18.5921 6.05077 18.6947 6.16763 18.7181C6.28449 18.7414 6.40159 18.6791 6.44743 18.5691C8.10549 14.5897 13.4945 14.5897 15.1526 18.5691C15.1984 18.6791 15.3155 18.7414 15.4324 18.7181C15.5492 18.6947 15.6333 18.5921 15.6333 18.4729V2.63959Z" stroke="white" stroke-opacity="0.4" stroke-width="0.5" stroke-linejoin="round"/> </svg>'
  }

  console.warn('bambooSswclient: cant build not in wishlist html');
};

bambooWishlistHelper.makeAddingToWishlistHtml = (params) => {
  return bambooWishlistHelper.makeNotInWishlistHtml(params);
};

bambooWishlistHelper.makeRemovingFromWishlistHtml = (params) => {
  return bambooWishlistHelper.makeInWishlistHtml(params);
};

bambooWishlistHelper.amountItemsInWishlist  = () => {
  const amountItems = Object.keys(bambooWishlistHelper.byProductId).length;

  document.getElementById('bambooWishlistCount').innerHTML = amountItems;

  const counterEl = document.getElementById('bambooWishlistCount');

  if (amountItems) {
    counterEl.style.display = 'flex';
  } else {
    counterEl.style.display = 'none';
  }
}

bambooWishlistHelper.initLocalWishlistPage = (params) => {
  const loadingDiv = document.getElementById('bamboo-local-wishlist-loading');
  const filledDiv = document.getElementById('bamboo-local-wishlist-filled');

  const countDiv = document.getElementById('bamboo-local-wishlist-count');

  let itemText = 'изделия';

  if (params.wishlist.length == 1) {
  	itemText = 'изделие';
  }
  countDiv.innerHTML = `<b>${params.wishlist.length}</b> ${itemText}`;

  if (params.wishlist.length === 0) {
    const emptyDiv = document.getElementById('bamboo-local-wishlist-empty');

    loadingDiv.style.display = 'none';
    emptyDiv.style.display = 'block';

    return;
  }

  params.wishlist.forEach(oneWishlistItem => {
    Shopify.getProduct(oneWishlistItem.handle, (product, textStatus) => {
      loadingDiv.style.display = 'none';
      filledDiv.style.display = 'block';

      params.localWishlistDivWrapper.innerHTML += BambooDynamicCollections.buildProductGridItem(product, {productsColumns: 1});
    });
  });
}



// Reviews. Extend bambooReviewsHelper object
bambooReviewsHelper = {
  loadProductReviews: true,
  productId: window.settings.product.id,
  reviewsData: [],
};

bambooReviewsHelper.renderFirstReviews = () => {
  const bambooReviewDataDiv = document.getElementById('bamboo-review-data');

  if (bambooReviewsHelper.reviewsData.length) {
  	const bambooReviewTab = document.getElementById('bamboo-review-tab');

    bambooReviewTab.style.display = 'block';
  }

  bambooReviewsHelper.reviewsData.forEach(oneReview => {
    const date = new Date(oneReview.creation_date.replaceAll("-","/"));

    //const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    //const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
    //const day = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(date);

    bambooReviewDataDiv.innerHTML += `
  	  <div class="review-item">
		<div class="top-panel">
			<div class="star-rating"><span id='star-rate' style="width: ${((oneReview.rate * 100) / 5) + '%'};"></span></div>
			<div class="date">${new Intl.DateTimeFormat('en-US', {year:"numeric",month:"short",day:"numeric"}).format(date)}</div>
		</div>
        <div class="body-panel">${oneReview.body}</div>
	  	${oneReview.author}
	  </div>
	`;

    if (oneReview.admin_reply) {
      const storeAnswerTabId = `bamboo-review-store-answer-tab-${oneReview.review_id}`;
      const storeAnswerBodyId = `bamboo-review-store-answer-${oneReview.review_id}`;

      bambooReviewDataDiv.innerHTML += `
		<div class="review-store">
          <div id='${storeAnswerTabId}' class="answer-header active">Store's answer</div>
          <div style='display: block;' id='${storeAnswerBodyId}' class="answer-body">${oneReview.admin_reply}</div>
		</div>
	  `;
    }
  });

  bambooReviewsHelper.reviewsData.forEach(oneReview => {
    if (oneReview.admin_reply) {
      const storeAnswerTabId = `bamboo-review-store-answer-tab-${oneReview.review_id}`;
      const storeAnswerBodyId = `bamboo-review-store-answer-${oneReview.review_id}`;

      bambooReviewsHelper.initToggleHandler({
        tabId: storeAnswerTabId,
        dataDivId: storeAnswerBodyId,
      });
    }
  });

};

bambooReviewsHelper.renderAverageRate = () => {
  const nValueRate = Number.parseFloat(bambooReviewsHelper.averageRateData.average_rate).toFixed(1);

  //const averageRateInTab = document.getElementById('bamboo-review-average-rate-in-tab');
  //averageRateInTab.innerHTML = Number.parseFloat(bambooReviewsHelper.averageRateData.average_rate).toFixed(1);


  const countRatesInTab = document.getElementById('bamboo-review-count-rates-in-tab');

  let itemText = 'reviews';
  let itemTextAverageScore = 'reviews, average score';

  if (bambooReviewsHelper.averageRateData.reviews_count == 1) {
  	itemText = 'review';
    itemTextAverageScore = 'review, average score';
  }
  countRatesInTab.innerHTML = `${bambooReviewsHelper.averageRateData.reviews_count} ${itemText}`;
  //countRatesInTab.innerHTML = bambooReviewsHelper.averageRateData.reviews_count;


  bambooReviewsHelper.initToggleHandler({tabId: 'bamboo-review-tab', dataDivId: 'bamboo-reviews-data'});


  const averageRateDataDiv = document.getElementById('bamboo-review-average-rate-data');

  //Rating panel
  var star_tab = document.getElementById('star-rating-in-tab');
  var star = document.getElementById('star-rating');

  star_tab.style.width = (((nValueRate * 100) / 5) - 2) + '%';
  star.style.width = (((nValueRate * 100) / 5) - 2) + '%';
  //

  averageRateDataDiv.innerHTML = `
	<div class="average_rate">${nValueRate}</div>
	<div>${bambooReviewsHelper.averageRateData.reviews_count} ${itemTextAverageScore}</div>
  `;
};

bambooReviewsHelper.initToggleHandler = params => {
  const tab = document.getElementById(params.tabId);
  const dataDiv = document.getElementById(params.dataDivId);

  tab.onclick = (e) => {
    if (dataDiv.style.display === 'none') {
      dataDiv.style.display = 'block';
      tab.classList.add('active');
    } else {
      dataDiv.style.display = 'none';
      tab.classList.remove('active');
    }
  };
};

bambooReviewsHelper.initPostReviewForm = () => {
  const postReviewForm = document.getElementById('bamboo-review-form');

  if (postReviewForm) {

    postReviewForm.onsubmit = e => {
      e.preventDefault();

      const reviewData = {};

      e.target.forEach(oneEl => {
        if (!oneEl.name) {
          return;
        }

        reviewData[oneEl.name] = oneEl.value;
      });

      pureSswClient.postReview(
          reviewData.email,
          reviewData.name,
          reviewData.body,
          Number(reviewData.rate),
          reviewData.title,
          reviewData.product_id,
          postReviewRes => {
            const reviewFormWrapper = document.getElementById('bamboo-review-form-wrapper');

            reviewFormWrapper.style.display = 'none';

            if (postReviewRes.status === 409) {
              const alreadyHaveReviewWarn = document.getElementById('bamboo-reviews-already-have-review-warn');

              alreadyHaveReviewWarn.style.display = 'block';

              return;
            }


            if (postReviewRes.status !== 200) {
              console.warn('bambooSswclient: something went wrong with post review');

              const somethingWentWrong = document.getElementById('bamboo-reviews-something-went-wrong');

              somethingWentWrong.style.display = 'block';

              return;
            }


            const posted = document.getElementById('bamboo-reviews-posted');

            posted.style.display = 'block';
          }
      );
    };
  }

};


// Init wishlist and reviews
var bambooSswclient;

const pureSswClient = new SSWClient("054d73720427cf968597a1b8b970133b", "8fda72a3dbc9813024fd6c010345f8c6");

if (bambooWishlistHelper.currentUserEmail) {
  bambooSswclient = pureSswClient;
} else {
  bambooSswclient = new bambooLocalSSWClient();
}


pureSswClient.getAppToken(function (getAppTokenResult) {
  if (!getAppTokenResult) {
    console.warn('bambooSswclient: no appToken received');

    return;
  }

  bambooSswclient.searchUser(bambooWishlistHelper.currentUserEmail, searchUserRes => {
    if (searchUserRes.status !== 200) {
      console.warn('bambooSswclient: something went wrong with search user');

      return;
    }

    bambooWishlistHelper.sswUserId = searchUserRes.data.user_id;

    bambooSswclient.getWishlist(searchUserRes.data.user_id, getWishlistRes => {

      if (getWishlistRes.status !== 200) {
        console.warn('bambooSswclient: something went wrong with getting wishlist');

        return;
      }


      if (searchUserRes.data.user_id != 'local') {
        const bambooLocalSswclient = new bambooLocalSSWClient();

        const localWishlist = bambooLocalSswclient.getWishlist(searchUserRes.data.user_id, getLocalWishlistRes => {
          getWishlistRes.data = getWishlistRes.data.concat(getLocalWishlistRes.data);

          bambooWishlistHelper.syncLocalWishlist({bambooLocalSswclient, localWishlist: getLocalWishlistRes.data});
        });
      }


      if (getWishlistRes.data.length) {
        bambooWishlistHelper.haveItems = true;
        bambooWishlistHelper.onHaveItems();
      } else {
        bambooWishlistHelper.haveItems = false;
        bambooWishlistHelper.onEmptyWishlist();
      }

      getWishlistRes.data.map(oneWishlistItem => {
        if (!bambooWishlistHelper.byProductId[oneWishlistItem.product_id]) {
          bambooWishlistHelper.byProductId[oneWishlistItem.product_id] = {
            byVariantId: {
              [oneWishlistItem.variant_id]: true
            }
          };

          return;
        }

        bambooWishlistHelper.byProductId[oneWishlistItem.product_id].byVariantId[oneWishlistItem.variant_id] = true;
      });

      bambooWishlistHelper.initAllHtmlElements({bambooSswclient});

      const localWishlistDivWrapper = document.getElementById('bamboo-local-wishlist');

      if (localWishlistDivWrapper) {
        bambooWishlistHelper.initLocalWishlistPage({localWishlistDivWrapper, wishlist: getWishlistRes.data });
      }


      bambooWishlistHelper.amountItemsInWishlist({wishlist: getWishlistRes.data});
    });


    if (bambooWishlistHelper.sswUserId === 'local' || !bambooReviewsHelper.loadProductReviews) {
      return;
    }
  });


  if (!bambooReviewsHelper.loadProductReviews) {
    return;
  }

  pureSswClient.rate([bambooReviewsHelper.productId], getAverageRateRes => {
    if (getAverageRateRes.status !== 200) {
      console.warn('bambooSswclient: something went wrong with getting average rate of reviews');

      return;
    }

    if (!getAverageRateRes.data.length) {
      return;

    }

    bambooReviewsHelper.averageRateData = getAverageRateRes.data[0];

    bambooReviewsHelper.renderAverageRate();
  });

  pureSswClient.reviews(bambooReviewsHelper.productId, getReviewsRes => {
    if (getReviewsRes.status !== 200) {
      console.warn('bambooSswclient: something went wrong with getting reviews');

      return;
    }

    bambooReviewsHelper.reviewsData = getReviewsRes.data.filter(oneItem => oneItem.status === 'published' && oneItem.product_id === bambooReviewsHelper.productId);

    bambooReviewsHelper.renderFirstReviews();
  });

  bambooReviewsHelper.initPostReviewForm();
});
